var SERVE_OUR_COMMUNITY = function(strictLocalize) {
    return {
        id: "serve-our-community",
        title: strictLocalize({
            id: "7ZMioe",
            defaultMessage: [
                {
                    type: 0,
                    value: "We serve our community"
                }
            ]
        }),
        description: strictLocalize({
            id: "paGUth",
            defaultMessage: [
                {
                    type: 0,
                    value: "Our work always starts with the mission. We\u2019re motivated every day to help our customers succeed against competitors a million times their size, and we fight hard to help level the playing field."
                }
            ]
        })
    };
};
var SEEK_THE_TRUTH = function(strictLocalize) {
    return {
        id: "seek-the-truth",
        title: strictLocalize({
            id: "3dR6eI",
            defaultMessage: [
                {
                    type: 0,
                    value: "We seek the truth"
                }
            ]
        }),
        description: strictLocalize({
            id: "x2gOqE",
            defaultMessage: [
                {
                    type: 0,
                    value: "We care deeply about getting to the right answer, and always dig to the root. We approach questions with an open, growth mindset, and are radically transparent when it comes to sharing the results we uncover."
                }
            ]
        })
    };
};
var BE_AN_OWNER = function(strictLocalize) {
    return {
        id: "be-an-owner",
        title: strictLocalize({
            id: "wqRJ8W",
            defaultMessage: [
                {
                    type: 0,
                    value: "We\u2019re all owners"
                }
            ]
        }),
        description: strictLocalize({
            id: "2zBgWD",
            defaultMessage: [
                {
                    type: 0,
                    value: "Each of us brings a founder\u2019s mindset to our work\u2014we\u2019re relentlessly resourceful, we raise the bar on quality, and we care less about the scope of our role than we do about ensuring the best work gets done."
                }
            ]
        })
    };
};
var EMBRANCE_THE_ADVENTURE = function(strictLocalize) {
    return {
        id: "embrace-the-adventure",
        title: strictLocalize({
            id: "fur73h",
            defaultMessage: [
                {
                    type: 0,
                    value: "We embrace the adventure"
                }
            ]
        }),
        description: strictLocalize({
            id: "dwmxjB",
            defaultMessage: [
                {
                    type: 0,
                    value: "We love nothing more than taking the big risk and daring greatly. We\u2019re resilient through change, have a bias towards action, and always find time to laugh, celebrate, and enjoy the ride."
                }
            ]
        })
    };
};
var BE_KIND = function(strictLocalize) {
    return {
        id: "be-kind",
        title: strictLocalize({
            id: "7aIaHX",
            defaultMessage: [
                {
                    type: 0,
                    value: "We\u2019re kind"
                }
            ]
        }),
        description: strictLocalize({
            id: "bzLlFp",
            defaultMessage: [
                {
                    type: 0,
                    value: "We don\u2019t shy away from direct feedback and conversation, because we always assume good intent. We\u2019re eager to help our teammates, share openly, and celebrate diverse perspectives."
                }
            ]
        })
    };
};
export var FAIRE_VALUES = function(strictLocalize) {
    return [
        SERVE_OUR_COMMUNITY(strictLocalize),
        SEEK_THE_TRUTH(strictLocalize),
        BE_AN_OWNER(strictLocalize),
        EMBRANCE_THE_ADVENTURE(strictLocalize),
        BE_KIND(strictLocalize)
    ];
};
